import HoverToolTip from "../../Common/ToolTips/HoverToolTips/HoverToolTip";
import BreakDownTableActions from "../schoolAdminPortal/videoPlayer/Breakdowns/BreakDownTableActions";

export const ManageBreakDownTableColumns = [
  {
    field: "breakdownName",
    headerName: "Breakdown Name",
    flex: 1,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    headerClassName: "table-header bold position-relative",
    renderCell: (params) => (
      <div className="position-absolute">
        <HoverToolTip
          content={<span>Default Breakdown.</span>}
          showToolTip={params?.row?.isDefault}
          variant="sm"
          trigger="hover"
        >
          <p className="link-blue text-width-auto mg-auto">
            <span>{params.row.breakdownName}</span>
            <span className="green bold">
              {" "}
              {params?.row?.isDefault ? "(D)" : ""}
            </span>
          </p>
        </HoverToolTip>
      </div>
    ),
  },
  {
    field: "breakdownTypeName",
    headerName: "Breakdown Type",
    flex: 1,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    headerClassName: "table-header bold",
    renderCell: (param) => <p>{param.row.breakdownType.breakdownTypeName}</p>,
  },
  {
    field: "possibleValues",
    headerName: "Possible Value",
    flex: 1,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    headerClassName: "table-header bold",
    renderCell: (params) => (
      <div className="d-flex-align-cent height-70 w-100">
        <p className="text-width-auto mg-auto">{params?.row?.possibleValues}</p>
      </div>
    ),
  },
  {
    field: "action",
    headerName: "Action",
    flex: 0.8,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    headerClassName: "table-header bold",
    sortable: false,
    renderCell: (param) => <BreakDownTableActions rowData={param.row} />,
  },
];
